/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomSelect } from 'src/components'
import type { DefaultOptionType } from 'antd/lib/select'
import styles from './SdgCompliancesMultiSelect.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { sdgCompliancesListSelector, setProjectFormItemValue } from 'src/features'
const { Option } = Select


const SdgCompliancesMultiSelect: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { data: sdgList } = useAppSelector(sdgCompliancesListSelector)

  const manageFiltering = (input: string, option: DefaultOptionType): boolean => {
    const sdgLabel = (option!.children[1]?.props?.children as unknown as string)
    return sdgLabel?.toLowerCase()?.includes(input?.toLowerCase())
  }

  const handleChange = (value: number[]) => {
    dispatch(setProjectFormItemValue({ key: 'sdg_compliances', value }))
  }

  return (
    <CustomSelect
      name='sdg_compliances'
      placeholder={t('Select SDGs')}
      required={false}
      mode='multiple'
      tokenSeparators={[' ', ',']}
      size='large'
      manageFiltering={manageFiltering}
      onChange={handleChange}
      listHeight={300}
    >
      {sdgList.map((sdg) => (
        <Option key={sdg.id} value={sdg.id}>
          <img
            src={sdg.icon}
            alt={`sdg-${sdg.name}`}
            className={styles.image}
          />
          <span className={styles.text}>
            {t(`sdgs.${sdg.id}`)}
          </span>
        </Option>
      ))}
    </CustomSelect>
  )
}

export default SdgCompliancesMultiSelect
